import { useEffect } from "react";
import { UserOutlined } from "@ant-design/icons";
import { App, Avatar, Button, Dropdown, Flex, Typography } from "antd";

import { useAuth } from "hooks/useAuth";
import useFetch from "hooks/useFetch";

const { Text } = Typography;

const ProfileDropdown = () => {
  const { message } = App.useApp();
  const { loading: loadingLogout, doFetch: postLogout } =
    useFetch("/auth/logout");
  const { loggedInUser, logoutUser } = useAuth();

  const menuItems = [{ key: "1", label: "Log Out" }];

  const logout = () => {
    postLogout().then((response) => {
      if (!!response?.success) {
        message.success("Successfully Log Out!");
        logoutUser();
      }
    });
  };

  useEffect(() => {
    if (loadingLogout) {
      message.loading("Logging Out", 0);
    }
  }, [loadingLogout]);

  const onMenuSelected = (e) => {
    switch (e.key) {
      case "1":
        logout();
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Dropdown
        menu={{ items: menuItems, onClick: onMenuSelected }}
        placement="bottomRight"
      >
        <Button type="text" size="large">
          <Flex align="center" gap="small">
            <Avatar icon={<UserOutlined />} size="small" />
            <Text>{loggedInUser}</Text>
          </Flex>
        </Button>
      </Dropdown>
    </>
  );
};

export default ProfileDropdown;
